module.exports = __webpack_public_path__ + "static/brunswick-yard-9d1ad9558261c7cd280b0bb8c697666b.jpg";